module.exports = {"140829100":"圣人涧镇","140829101":"常乐镇","140829102":"张店镇","140829103":"张村镇","140829104":"曹川镇","140829105":"三门镇","140829200":"洪池乡","140829201":"杜马乡","140829202":"部官乡","140829203":"坡底乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140829.json
// module id = 301
// module chunks = 0